import styled from 'styled-components';
import { readableColor } from 'polished';
import { tvar } from '@versita/frontend/design-tokens';

export const StyledCalendarHeader = styled.header`
  max-width: 40rem;
  display: flex;
  margin-bottom: ${tvar('space.x3')};

  h2 {
    margin-bottom: 0;
  }
`;

export const StyledCalendarHeaderControls = styled.div`
  margin-left: auto;
`;

export const StyledCalendarHeaderControl = styled.button`
  font-size: 3rem;
  background: transparent;
  border: 0;
  cursor: pointer;
  color: ${tvar('colors.brand.primary')};
`;

export const StyledCalendar = styled.div`
  max-width: 40rem;
  display: grid;
  grid-template-columns: repeat(7, fit-content(4.2rem));
  justify-content: space-between;
  &:not(:last-child) {
    margin-bottom: ${tvar('space.x3')};
  }
`;

export const StyledCalendarWeekdays = styled.div`
  text-align: center;
  font-size: ${tvar('typographies.small.fontSize')};
  color: ${tvar('colors.neutrals.grey4')};
  margin-bottom: ${tvar('space.x2')};
`;

export const StyledCalendarDate = styled.button<{
  $selected: boolean;
  $today: boolean;
  $dim: boolean;
}>`
  text-align: center;
  border: 0;
  cursor: ${({ $dim }) => ($dim ? 'default' : 'pointer')};
  justify-content: center;
  padding: calc(${tvar('space.x1')} * 1.2);
  color: ${({ theme, $dim, $selected }) =>
    $dim
      ? theme.colors.neutrals.grey4
      : $selected
        ? readableColor(theme.colors.button.primary.bg)
        : theme.colors.typography.default};
  background: ${({ theme, $dim, $selected, $today }) =>
    !$dim && $selected
      ? theme.colors.button.primary.bg
      : !$dim && $today
        ? theme.colors.neutrals.grey3
        : 'transparent'};
  @media (min-width: ${tvar('measures.breakpoints.tabletLg')}) {
    padding: calc(${tvar('space.x1')} * 1.5);
  }
`;
